import AccountDetailModal from './AccountDetailModal';
import { useDrilldown } from './DrilldownProvider';
import InvRecordModal from './InvRecordModal';
import PurchaseDetailModal from './PurchaseDetailModal';
import StoreDrilldownModal from './StoreDrilldownModal';
import TicketDetailModal from './TicketDetailModal';

/**
 * Renders the top of the drill-down stack (JCD-59).
 *
 * Only the top: a nested drill replaces what is on screen and offers a back
 * arrow, rather than stacking scrims until the page is unreadable.
 */
export default function DrilldownHost() {
  const { top, depth, back, close, user } = useDrilldown();
  if (!top) return null;

  const onBack = depth > 1 ? back : undefined;

  switch (top.kind) {
    case 'tkt':
      return (
        <TicketDetailModal
          sid={top.sid}
          tnum={top.tnum}
          // The ref may veto the CFDI buttons (a transfer has no invoice);
          // otherwise fall back to the role rule the pages used inline.
          // An unloaded user resolves to false, not true: `user?.role !==
          // 'staff'` would be true while /api/me is still in flight and flash
          // download buttons at a staff user. The server enforces either way.
          canDownloadInvoice={top.invoice ?? (user !== null && user.role !== 'staff')}
          onClose={close}
          onBack={onBack}
        />
      );
    case 'account':
      return <AccountDetailModal anum={top.anum} onClose={close} onBack={onBack} />;
    case 'order':
      return <PurchaseDetailModal sid={top.sid} onum={top.onum} onClose={close} onBack={onBack} />;
    case 'inv':
      return (
        <InvRecordModal
          sid={top.sid}
          line={top.line}
          part={top.part}
          onClose={close}
          onBack={onBack}
        />
      );
    case 'store':
      return (
        <StoreDrilldownModal
          sid={top.sid}
          date={top.date}
          storeName={top.storeName}
          onClose={close}
          onBack={onBack}
        />
      );
  }
}
